import React from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";
import { automationTestIds } from "../../testing/automationTestIds";
import { cssVar, DASHBOARD_CHART_CSS_VARS } from "../../utils/cssVariables";

export const dashboardBarChartId = automationTestIds.dashboardChartBar;
export const BAR_CHART_HEIGHT = 420;

export const getColumnChartSeries = (issuedCredentials) => {
  return [
    {
      name: "Issued Credentials",
      data: issuedCredentials?.length
        ? issuedCredentials
        : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
  ];
};

export const getColumnChartOptions = (months, t) => {
  //! months backend response - no using for now
  const translatedMonths = [
    t("dashboard:january"),
    t("dashboard:february"),
    t("dashboard:march"),
    t("dashboard:april"),
    t("dashboard:may"),
    t("dashboard:june"),
    t("dashboard:july"),
    t("dashboard:august"),
    t("dashboard:september"),
    t("dashboard:october"),
    t("dashboard:november"),
    t("dashboard:december"),
  ];
  return {
    chart: {
      type: "bar",
      width: "100%",
      height: BAR_CHART_HEIGHT,
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
        backgroundColor: "#000000",
      },
      onDatasetHover: {
        style: {
          fontSize: "12px",
          fontFamily: undefined,
        },
      },
      theme: "dark",
    },
    xaxis: {
      categories: translatedMonths,
      show: true,
      labels: {
        show: true,
        style: {
          colors: cssVar(DASHBOARD_CHART_CSS_VARS.axisLabel),
          fontSize: "14px",
          fontWeight: "500",
        },
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
    },
    yaxis: {
      show: true,
      color: "black",
      labels: {
        show: true,
        style: {
          colors: cssVar(DASHBOARD_CHART_CSS_VARS.gridLabel),
          fontSize: "14px",
        },
      },
    },
    grid: {
      show: true,
      strokeDashArray: 5,
      yaxis: {
        lines: {
          show: true,
        },
      },
      xaxis: {
        lines: {
          show: true,
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        colorStops: [
          [
            {
              offset: 0,
              color: cssVar(DASHBOARD_CHART_CSS_VARS.barGradientStart),
              opacity: 1,
            },
            {
              offset: 100,
              color: cssVar(DASHBOARD_CHART_CSS_VARS.barGradientEnd),
              opacity: 0.28,
            },
          ],
        ],
      },
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 2,
        columnWidth: "15px",
      },
    },
  };
};

export const DashboardBarChart = ({ options, series, className }) => (
  <div id={dashboardBarChartId}>
    <Chart
      options={options}
      series={series}
      type="bar"
      className={className}
    />
  </div>
);

DashboardBarChart.propTypes = {
  options: PropTypes.object.isRequired,
  series: PropTypes.array.isRequired,
  className: PropTypes.string,
};

DashboardBarChart.defaultProps = {
  className: "",
};
